import React from 'react';
import { GlobalStyles as BaseGlobalStyles } from '@/ui';
import { Fonts } from './Font';

export function GlobalStyles() {
	return (
		<>
			<Fonts />
			<BaseGlobalStyles />
		</>
	);
}
